const referencePrefix = 'ts_';

export default (bankingConfig, webhookData, bankId) => {
  const { siteSlug, url } = bankingConfig;
  const params = {
    site: siteSlug,
    referenceid: [
      referencePrefix,
      webhookData,
    ].join(''),
  };
  if (bankId) {
    params.bankid = bankId;
    params.hide_options = true;
    params.hide_logo = true;
  }
  const queryString = new URLSearchParams(params).toString();
  return `${url}/customer/web/create?${queryString}`;
};
